import React from "react";
import HowItWorks from "../../components/HowItWorks";
import HiringProcess from "../../components/HiringProcess";
import Showcase from "../../components/Showcase";
import ShowOff from "../../components/ShowOff";
import Header from "../../components/Header";
import OurExpertise from "../../components/OurExpertise";
import Partners from "../../components/Partners";
import Hero from "../../components/Hero";
import Footer from "../../components/Footer";
import Meta from "../../components/Meta";
import "../../styles/home.css";
import herobg from "../../assets/herobg.mp4";
import videohero from "../../assets/videohero.mp4";

const Home = () => {
  return (
    <div className="w-100">
      <Meta />
      <div className="herobg text-white position-relative">
        {/* <div className="video-overlay"></div>
        <video class="video" muted playsinline loop autoPlay src={videohero} type="video/mp4"></video> */}
        <Header />
        <Hero />
      </div>
      {/* <Partners /> */}
      <ShowOff />
      <HowItWorks />
      <HiringProcess />
      <OurExpertise />
      <Showcase />
      <Footer />
    </div>
  );
};

export default Home;
